<template>
  <div v-if="cart.gift_vouchers && cart.gift_vouchers.length" id="cart-credit-notes" class="float-none mb-2 text-right">
    <p v-for="(giftVoucherCode, k) in cart.gift_vouchers" :key="k">
      Gift Voucher {{ giftVoucherCode.code }}:
      <button class="btn btn-link text-danger pt-0" @click="remove(giftVoucherCode)" :disabled="removing[giftVoucherCode.id]"><i class="fas fa-times"></i></button>
      <span class="amount">{{ giftVoucherCode.amount | numberToRs }}</span>
    </p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SaleCartGiftVouchers',
  props: [
    'cart'
  ],
  data () {
    return {
      removing: {}
    }
  },
  methods: {
    remove (giftVoucherCode) {
      this.removing[giftVoucherCode.id] = true

      let postData = {
        include_cart: true
      }

      axios.delete(process.env.URLS_PUBLIC_API + '/cart/' + this.$parent.cart.id + '/gift_vouchers/' + giftVoucherCode.id, {
        data: postData
      }).then((response) => {
        this.$parent.cart = response.data.data.cart

        setTimeout(() => {
          this.$parent.setPaneHeights()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to remove the credit note.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.removing[giftVoucherCode.id] = false
      })
    }
  }
}
</script>

<style scoped>
p {
  font-size: 1.1rem;
}
p:last-child {
  margin-bottom: 0 !important;
}
.amount {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/sale/partials/CartGiftVouchers.vue